import React from "react";
import { Form } from "@redriver/cinnamon";

const PaperInclusiveTermsForm = ({ onChangeUpload, editMode, ...props }) => {
  return (
    <Form {...props}>
      <Form.FileUpload
        field="templateUpload"
        label="Upload Template"
        fileExtensionTypes={["docx"]}
        customValidator={(_, __, ___, { value }) => {
          !!value?.templateUpload && onChangeUpload(value?.templateUpload);
        }}
        required={!editMode}
      />
    </Form>
  );
};

export default PaperInclusiveTermsForm;
